import styled from "styled-components";

export default styled.div`

&{
  width: 100%;
  height: 100%;
  overflow:scroll;
  background-color: ${props => props.theme.colors.primary_light};
}
.button{
  margin-left:10px;
  margin-top: 20px;
  margin-bottom: 20px;
}
input, select{
  height:30px;
}
div>label, div>input{
  margin-left:10px;
}
h4{
  display:flex;
  align-items: center;
  justify-content: center;
}
.centralizedDiv{
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-start;

  label{
    margin-bottom: 0px;
  }
}
input[type='checkbox'] {
  height: 100%;
 }
`
